import { createSlice } from '@reduxjs/toolkit';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';
import {
  QCTaskExecutionState,
  QCTaskExecutionFetchRequestAction,
  QCTaskExecutionFetchSuccessAction,
  DownloadExportFileAction,
} from '@restore/QCTaskExecutions/QCTaskExecutions.types';

const initialState: QCTaskExecutionState = {
  loading: false,
  error: false,
  data: null,
};

const { actReq, actResolve, actReject, actEmpty } =
  makeActionCreator<QCTaskExecutionState>();

export const qcTaskExecutionsSlice = createSlice({
  name: 'qcTaskExecutions',
  initialState,
  reducers: {
    pollExecutions: actEmpty<void>(),
    fetchQCTaskExecutionsRequest:
      actReq<QCTaskExecutionFetchRequestAction['payload']>(),
    fetchQCTaskExecutionsSuccess:
      actResolve<QCTaskExecutionFetchSuccessAction['payload']>(),
    fetchQCTaskExecutionsRequestFailure: actReject(),

    downloadExportFile:
      actEmpty<DownloadExportFileAction['payload']>(),

    clear: state => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.loading = initialState.loading;
    },
  },
});

export const actions = {
  ...qcTaskExecutionsSlice.actions,
};

export const useQCTaskExecutionsSlice = createSliceHook(
  qcTaskExecutionsSlice.name,
  actions
);

export const selectQCTaskExecutionsState = createSelector(
  qcTaskExecutionsSlice.name
);
